import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { appendOnboarding } from '../../../../features/session/sessionSlice';
import { appendModel } from '../../../../features/site/siteSlice';
import { serviceMap } from '../../../utils/common';

import ServiceCard from '../../Admin/ServiceTypes/ServiceCard';

import FacebookInsights from '../Services/SocialMedia/FacebookInsights';
import GoogleBusinessProfile from '../Services/SocialMedia/GoogleBusinessProfile';
import LinkedinOrg from '../Services/SocialMedia/LinkedinOrg';
import SummaryCard from '../Services/SocialMedia/SummaryCard';

const SOCIALS = ["gmb", "fbPage", "linkedinOrg"]

function SocialMedia(props){
    const dispatch = useDispatch()

    const state = useSelector(state => state.session.onboarding)
    const model = useSelector(state => state.site.model)
    
    const nextEnabled = (state.dontHaveIt.fbPage || model.siteForm?.attr?.accounts?.fbPage) &&
        (state.dontHaveIt.gmb || model.siteForm?.attr?.accounts?.gmb) &&
        (state.dontHaveIt.linkedinOrg || model.siteForm?.attr?.accounts?.linkedinOrg)

    const unsetService = async(service) => {
        await dispatch(appendModel({
            siteForm: {
                ...model.siteForm,
                attr: {
                    ...model.siteForm.attr,
                    accounts: {
                        ...(model.siteForm?.attr?.accounts ?? {}),
                        [service]: undefined
                    }
                }
            }
        }))

        localStorage.removeItem(`${service}Selection`)
    }

    const { socialMediaService, animationClass } = state
    const { siteForm } = model

    const summaryEnabled = (service) => SOCIALS.reduce((prev, curr) => {
        if(!state.dontHaveIt[curr] && (!model.siteForm?.attr?.accounts || !model.siteForm?.attr?.accounts[curr]) && curr !== service){
            prev = false
        }

        return prev
    }, true)

    const onAction = (service, nextService, dontHaveIt=false) => {
        dispatch(appendOnboarding({
            dontHaveIt: {
                ...state.dontHaveIt,
                [service]: dontHaveIt
            },
            animationClass: "service-selection",
            socialMediaService:  nextEnabled || summaryEnabled(service) ? "summary" : nextService
        }))
        if(dontHaveIt){
            unsetService(service)
        }
    }
    
    return <>
        <div class="d-flex justify-content-center align-items-center flex-sm-row flex-column">
            <SwitchTransition mode={"out-in"}>
                <CSSTransition
                    key={socialMediaService}
                    addEndListener={(node, done) => {
                        node.addEventListener("transitionend", done, false);
                    }}
                    classNames={animationClass}>
                    <div className="service-container">
                        {socialMediaService === "gmb" && <GoogleBusinessProfile 
                            onSave={(service) => onAction(service, "fbPage")} 
                            onCancel={(service) => onAction(service, "fbPage", true)} />}
                        {socialMediaService === "fbPage" && <FacebookInsights 
                            onSave={(service) => onAction(service, "linkedinOrg")} 
                            onCancel={(service) => onAction(service, "linkedinOrg", true)} />}
                        {socialMediaService === "linkedinOrg" && <LinkedinOrg 
                            onSave={ (service) => onAction(service, "gmb")} 
                            onCancel={(service) => onAction(service, "gmb", true)} />}

                        {socialMediaService === "summary" && <SummaryCard />}
                    </div>
                </CSSTransition>
            </SwitchTransition>
            <div className="ml-4 d-none d-sm-block">
                {Object.values(serviceMap).filter(s => SOCIALS.includes(s.key)).map(service => <div className="text-center mb-4">
                    <ServiceCard 
                        {...service} 
                        id={`${service.key}-service-card`}
                        active={socialMediaService === service.key}
                        onChosen={() => dispatch(appendOnboarding({
                            animationClass: "service-selection-r",
                            socialMediaService: service.key
                        }))} 
                        overrideIcon={state?.dontHaveIt[service.key] ? <i class="fas fa-minus-circle text-warning fa-1-5"></i> : siteForm?.attr?.accounts && siteForm?.attr?.accounts[service.key] ? <i class="fas fa-check-circle text-success fa-1-5"></i> : null}
                    />
                </div>)}
            </div>
        </div>
        <div className="d-flex justify-content-between d-sm-none align-items-stretch">
            {Object.values(serviceMap).filter(s => SOCIALS.includes(s.key)).map(service => <div className="w-100">
                <ServiceCard 
                    {...service} 
                    active={socialMediaService === service.key}
                    onChosen={() => dispatch(appendOnboarding({
                        animationClass: "service-selection-r",
                        socialMediaService: service.key
                    }))} 
                    overrideIcon={state?.dontHaveIt[service.key] ? <i class="fas fa-minus-circle text-warning fa-1-5"></i> : siteForm?.attr?.accounts && siteForm?.attr?.accounts[service.key] ? <i class="fas fa-check-circle text-success fa-1-5"></i> : null}
                />
            </div>)}
        </div>
    </>
}

export default SocialMedia